import { render, staticRenderFns } from "./withdrawalHandle.vue?vue&type=template&id=1761d544&scoped=true"
import script from "./withdrawalHandle.vue?vue&type=script&lang=ts"
export * from "./withdrawalHandle.vue?vue&type=script&lang=ts"
import style0 from "./withdrawalHandle.vue?vue&type=style&index=0&id=1761d544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1761d544",
  null
  
)

export default component.exports